var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4001 11.9996C20.4001 16.6388 16.6393 20.3996 12.0001 20.3996C7.36091 20.3996 3.6001 16.6388 3.6001 11.9996C3.6001 7.36042 7.36091 3.59961 12.0001 3.59961C16.6393 3.59961 20.4001 7.36042 20.4001 11.9996ZM13.0501 7.79961C13.0501 8.37951 12.58 8.84961 12.0001 8.84961C11.4202 8.84961 10.9501 8.37951 10.9501 7.79961C10.9501 7.21971 11.4202 6.74961 12.0001 6.74961C12.58 6.74961 13.0501 7.21971 13.0501 7.79961ZM10.9501 10.9496C10.3702 10.9496 9.9001 11.4197 9.9001 11.9996C9.9001 12.5795 10.3702 13.0496 10.9501 13.0496V16.1996C10.9501 16.7795 11.4202 17.2496 12.0001 17.2496H13.0501C13.63 17.2496 14.1001 16.7795 14.1001 16.1996C14.1001 15.6197 13.63 15.1496 13.0501 15.1496V11.9996C13.0501 11.4197 12.58 10.9496 12.0001 10.9496H10.9501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.ccaea9bb308ad9834e0fbbdb3eda21bc.svg";
export { ForwardRef as ReactComponent };